<template>
    <svg width="260" height="260" viewBox="0 0 260 260" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            width="260"
            height="260"
            rx="130"
            fill="#181A1C"
        />
        <path
            d="M52.5 180.223C70.2087 204.317 98.3098 220 130 220C161.69 220 189.791 204.317 207.5 180.222C188.103 170.684 160.394 160 130 160C99.6078 160 71.9012 170.683 
                52.5 180.223Z"
            fill="#34373B"
        />
        <path
            d="M182.5 91.9685C182.5 62.8552 159.406 40 130 40C100.594 40 77.5 63.6871 77.5 92.8004C77.5 121.914 100.594 145 130 145C159.406 145 182.5 121.082 182.5 91.9685Z"
            fill="#34373B"
        />
    </svg>
</template>
